/*
 @flow
 @format
*/

import { API_URL } from '../config';

const apiPost = (url: string = '', data: {} = {}, isJson: boolean = true): Promise<any> => {
  return new Promise((resolve, reject) => {
    const opts = {
      method: 'POST', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      credentials: 'same-origin', // include, *same-origin, omit
      redirect: 'follow', // manual, *follow, error
      referrer: 'no-referrer', // no-referrer, *client
    };

    if (isJson) {
      opts.headers = { 'Content-Type': 'application/json', 'X-API-Key': '66qY7JgLnys2s5MmvgAa26HeBnpSNCeW2RtAxK43QMExv5jnNzguzzNCGfTw9TnY' };
    }

    const handleResponse = response => {
      const jResponse = response.json(); // isJson ? response.json() : response;
      if (response.status !== 200) {
        reject(jResponse.error);
      } else {
        resolve(jResponse);
      }
    };

    const sendRequest = (srUrl, srOpts) =>
      fetch(`${API_URL}${srUrl}`, srOpts)
        .then(handleResponse)
        .catch(err => reject(err));

    if (isJson) {
      sendRequest(url, { ...opts, body: JSON.stringify(data) });
    } else {
      const formData = new FormData();
      for (const fieldName of Object.keys(data)) {
        console.log(`append filedname: ${fieldName} length data: ${data[fieldName].length}`);
        formData.append(fieldName, data[fieldName]);
      }
      sendRequest(url, { ...opts, body: formData });
    }
  });
};

export { apiPost };
